import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProfilePageContainer from 'shared/profile/ProfilePageContainer';
import ProfilePageSectionContainer from 'shared/profile/ProfilePageSectionContainer';
import { getTeamPackagesAction, searchTeamPackagesAction } from './actions/packagesPage';
import { RootState } from 'redux/store';
import { isArray } from 'lodash';
import { Package } from './types';
import PackageSection from './components/PackageSection';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';
import paths from 'paths';
import { useHistory } from 'react-router-dom';
import InputSearch from 'shared/inputs/InputSearch';

const PackagesPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { packages } = useSelector((state: RootState) => state.packagesPage);
  const { team } = useSelector((state: RootState) => state.profile);

  const [searchTerm, setSearchTerm] = useState('');
  const [time, setTime] = useState('');

  const handleSearch = (e?: any) => {
    if (e) e.preventDefault();
    if (searchTerm) dispatch(searchTeamPackagesAction({ query: searchTerm }));
  };

  useEffect(() => {
    const currentTime = new Date().toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    setTime(currentTime);
  }, [packages]);

  const handleReset = () => {
    setSearchTerm('');
    dispatch(getTeamPackagesAction());
  };

  useEffect(() => {
    dispatch(getTeamPackagesAction());
  }, [team]);

  const switchToProjectsView = () => {
    history.push(paths.profileProjects + history.location.search);
  };

  return (
    <div className="bg-ev-light-yellow">
      <ProfilePageContainer
        title={'Packages'}
        header={
          <span className="flex">
            <span>Packages</span>
            <div className="ml-auto">
              <PrimaryButton
                text={'Switch to Projects'}
                onClick={switchToProjectsView}
                buttonColor={ButtonColor.White}
                buttonType={ButtonType.Action}
              />
            </div>
          </span>
        }
        description={'The packages page features ready-made projects designed for various major events.'}
      >
        <ProfilePageSectionContainer>
          <InputSearch
            label=""
            placeholder="Search by title"
            value={searchTerm}
            reset={handleReset}
            onChange={setSearchTerm}
            onClick={handleSearch}
            simple={true}
            className="p-4"
          />

          {isArray(packages) &&
            packages.map((packageDetails: Package, index) => {
              return (
                <PackageSection
                  packageDetails={packageDetails}
                  index={index}
                  key={`package-${packageDetails.uuid}-${index}-${time}`}
                />
              );
            })}

          {!isArray(packages) && (
            <div>
              You have no package. Email&nbsp;
              <a title="email sales" href="mailto:sales@everviz.com">
                sales@everviz.com
              </a>
              &nbsp;for more information
            </div>
          )}
        </ProfilePageSectionContainer>
      </ProfilePageContainer>
    </div>
  );
};

export default PackagesPage;
